import React, { useState } from 'react';
import { Tabs, Tab, Container, Typography, Box } from '@mui/material';
import NotificationSettings from './SettingsTabs/NotificationsPreferences';

const Preferences = () => {
    const [activeTab, setActiveTab] = useState('notifications');

    const renderContent = () => {
        switch (activeTab) {
            case 'notifications':
                return <NotificationSettings />;
            case 'account':
                return <div></div>;
            case 'privacy':
                return <div></div>;
            case 'theme':
                return <div></div>;
            default:
                return <NotificationSettings />;
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <section id="company_dashboard" className="settings-dashboard">
            <Container>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab label="Notifications" value="notifications" />
                    <Tab label="- - -" value="account" />
                    <Tab label="- - -" value="privacy" />
                    <Tab label="- - -" value="theme" />
                </Tabs>
                <Box mt={3}>
                    {renderContent()}
                </Box>
            </Container>
        </section>
    );
};

export default Preferences;